/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable eqeqeq */
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  KeyOutlined,
  PlusOutlined,
  UserDeleteOutlined,
  UserOutlined,
} from '@ant-design/icons';
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Input,
  Modal,
  Progress,
  Row,
  Select,
  Table,
  Tabs,
  Tag,
  Tooltip,
  Switch,
} from 'antd';
import { VscFolder } from 'react-icons/vsc';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/vi';
import React, {
  Fragment,
  useCallback,
  useEffect,
  useState,
  useRef,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import {
  getExportReportLogsApi,
  getExportReportsApi,
  getReportNotificationsApi,
} from '../../api/customerApi';
import colorsDark from '../../assets/colors/dark';
import Action_logs from '../../assets/icons/Action_logs.svg';
import AddDeviceNotification from '../../assets/icons/add_service.svg';
import AdvertiseNotification from '../../assets/icons/advertise.svg';
import AlertNotification from '../../assets/icons/alert.svg';
import CarNotification from '../../assets/icons/car_noti.svg';
import DisconnectedDeviceNotification from '../../assets/icons/disconnect_device.svg';
import EventObjectDetectionNotification from '../../assets/icons/event_detect.svg';
import CameraTampering from '../../assets/icons/camera_tampered.svg';
import Group_Members from '../../assets/icons/Group_Members.svg';
import KnifeNotification from '../../assets/icons/knife_noti.svg';
import Members from '../../assets/icons/Members.svg';
import MotobikeNotification from '../../assets/icons/motobike_noti.svg';
import PeopleNotification from '../../assets/icons/people_notif.svg';
import RemoveDeviceNotification from '../../assets/icons/remove_device.svg';
import SungNotification from '../../assets/icons/sung_noti.svg';
import UpdateSystemNotification from '../../assets/icons/update_system.svg';
import Whitelist_Device from '../../assets/icons/Whitelist_Device.svg';
import Whitlist_IP from '../../assets/icons/Whitlist_IP.svg';
import * as SERVICE from '../../constants/service.types';
import {
  ACTION_LOGS,
  NAMESPACE,
  NOTIFIES,
  DECODED_ACCESS_TOKEN,
  USER_TYPE_OPTIONS,
  ACCOUNT_STATUS,
} from '../../constants/system.keys';
import * as ACTIONS from '../../redux/actions';
import {
  openMessage,
  socketEmitEvent,
  clearListGroupByParentGroup,
  clearGroupAccountMember,
} from '../../redux/actions';
import './index.scss';
import AddGroupMember from './Modals/AddGroupMember';
import AddMemberSteps from './Modals/AddMemberSteps';
import AddWhitelistDeviceComponent from './Modals/AddWhitelistDevice';
import AddWhitelistIPComponent from './Modals/AddWhitelistIP';
import ChangePasswordComponent from './Modals/ChangePassword';
import UpdateMemberComponent from './Modals/UpdateMember';
import storageService from '../../services/storage.service';
import Folder from './Folder';
import { ActionLog } from './ActionLog';
import { beeXLogger } from '../../helpers/logger';
import { RemoveListMember } from './Modals/RemoveListMember';

const { confirm } = Modal;
const { TabPane } = Tabs;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { Search } = Input;
function getTimeFromMins(mins) {
  // do not include the first validation check if you want, for example,
  // getTimeFromMins(1530) to equal getTimeFromMins(90) (i.e. mins rollover)
  if (mins >= 1440 || mins < 0) {
    return 'NaN:NaN AM';
  }
  var h = (mins / 60) | 0,
    m = (mins % 60) | 0;
  return moment.utc().hours(h).minutes(m).format('hh:mm A');
}
const ActionTagColors = (actionName) => {
  switch (actionName) {
    case 'Delete':
      return colorsDark.$errors;

    case 'Add':
      return colorsDark.$online;

    case 'Update':
      return colorsDark.$warning;

    default:
      return colorsDark.$offline;
  }
};
const memberRoleColors = (roleName) => {
  switch (roleName) {
    case 'admin':
      return colorsDark.$online;
    default:
      return colorsDark.$offline;
  }
};

const SystemPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    dataUser,
    accountByNamespace,
    isAuth,
    logsByNamespace,
    namespace: localNamespace,
    userId,
    whiteListIPs: listWhitelistIPs,
    deleteWhiteListIP,
    whiteListDevices: listWhitelistDevices,
    deleteWhiteListDevice,
    groupMembers: listGroupMembers,
    updateGroupMembers,
    deleteGroupMembers,
    filterNotifications,
    listAlert,
    updateMemberToNamespace,
    listGroupByParentGroup,
    addGroupMembers,
    listDataSearch,
    checkRemoveGroup,
    // accountByNamespaceByPage,
    removeMemberToNamespace,
  } = useSelector((state) => state);
  const [isAdmin, setIsAdmin] = useState(false);
  const [timeRequest] = useState(new Date().getTime());
  const [requestUpdateId, setRequestUpdateId] = useState(0);

  const [currentTab, setCurrentTab] = useState('notifications');
  const [visibleEditMember, setVisibleEditMember] = useState(null);
  const [visibleChangePassword, setVisibleChangePassword] = useState(false);
  const [visibleAddMember, setVisibleAddMember] = useState(false);
  const [visibleRemoveListMember, setVisibleRemoveListMember] = useState(false);
  const [visibleAddWhiteListIp, setVisibleAddWhiteListIp] = useState(false);
  const [visibleAddWhiteListDevice, setVisibleAddWhiteListDevice] =
    useState(false);
  const [visibleGroupMembers, setVisibleAddGroupMembers] = useState(false);
  const [namespace, setNamespace] = useState();
  const [memberTabLoading, setMemberTabLoading] = useState(false);
  const [groupMemberTabLoading, setGroupMemberTabLoading] = useState(false);
  const [logsTabLoading, setLogsTabLoading] = useState(false);
  const [accountByNamespaceDataDefault, setAccountByNamespaceDataDefault] =
    useState();
  const [accountByNamespaceData, setAccountByNamespaceData] = useState({
    data: [],
    pagination: {},
    loading: false,
    total: 0,
  });
  const [whiteListIPs, setWhiteListIPs] = useState();
  const [whiteListDevices, setWhiteListDevices] = useState();
  const [groupMembersDefault, setGroupMembersDefault] = useState();
  const [groupMembers, setGroupMembers] = useState();
  const [dataArr, setDataArr] = useState({});
  const [logs, setLogs] = useState({
    data: [],
    pagination: {},
    loading: false,
  });
  const [dataMember, setDataMember] = useState({
    data: [],
    pagination: {},
    loading: false,
  });
  const [dataMemberSearch, setDataMemberSearch] = useState();
  const [key, setKey] = useState(Math.random());
  const [keyMember, setKeyMember] = useState(Math.random());
  const [keyWhiteListIP, setKeyWhiteListIP] = useState(Math.random());
  const [dateRanger, setDateRanger] = useState([
    moment(
      moment().subtract(1, 'days').set({ hour: 0, minute: 0, second: 0 }),
    ).valueOf(),
    moment().valueOf(),
  ]);
  const [dataFilterType, setDataFilterType] = useState('disconnected_device');
  const [percent, setPercent] = useState(0);
  const [dataNotification, setDataNotifcation] = useState({
    data: [],
    pagination: {
      current: 2,
      pageSize: 10,
    },
    loading: false,
  });
  const [expKeys, setExpKeys] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataDetail, setDataDetail] = useState();
  const [keyRanger, setKeyRanger] = useState(Math.random());
  const [isLoadingExport, setIsLoadingExport] = useState(false);
  const [isLoadingExportLogs, setIsLoadingExportLog] = useState(false);
  const [isLoadingDownloadNotification, setIsLoadingDownloadNotification] =
    useState(false);
  const [dataSearchLogs, setDataSearchLogs] = useState();
  const [dataFilterTypeLog, setDataFilterTypeLog] = useState('Login');
  const [dataFilterTypeMember, setDataFilterTypeMember] =
    useState('phoneNumber');
  const { accountGroupMembers } = useSelector((state) => state);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [membersGroup, setMembersGroup] = useState([]);
  const [fileData, setFileData] = useState([]);
  const [userType, setUserType] = useState('');
  const [expandedKeys, setExpandedKeys] = useState({});

  const toggleExpand = (member) => {
    setExpandedKeys((prev) => ({ ...prev, [member.id]: !prev[member.id] }));
    onExpandData(member);
  };

  const [activeDropdownKey, setActiveDropdownKey] = useState(null);
  const [idParentSelected, setIdParentSelected] = useState(null);
  const [recordSelected, setRecordSelected] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState('');
  const inputValueRef = useRef(null);
  // const [listMemberOfGroup, setListMemberOfGroup] = useState([]);

  const [explorerDataList, setExplorerDataList] = useState([]);

  const [valueInput, setValueInput] = useState('');
  const [progressMap, setProgressMap] = useState({});
  const [queue, setQueue] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [notificationInputSearch, setNotificationInputSearch] = useState('');

  const [
    isPopupConfirmDeleteGroupVisible,
    setIsPopupConfirmDeleteGroupVisible,
  ] = useState(false);
  const [
    isPopupConfirmDeleteMemberVisible,
    setIsPopupConfirmDeleteMemberVisible,
  ] = useState(false);

  const [error, setError] = useState(false);

  const handleConfirmDeleteMember = () => {
    // if (valueInputConfirm && valueInputConfirm === recordSelected.fullName) {
    setIsPopupConfirmDeleteMemberVisible(false);
    onDelete(recordSelected.accountId);
    // } else {
    //   setError(true);
    // }
  };

  const handleConfirmDeleteGroup = () => {
    setIsDisabled(true);
    // setIsPopupConfirmDeleteGroupVisible(false);
    for (let i = 0; i < dataRemoveGroup.length; i++) {
      onRemoveGroupMember(dataRemoveGroup[i].id);
    }
  };

  useEffect(() => {
    if (isDisabled) {
      document.getElementsByTagName('body')[0].style.pointerEvents = 'none';
    } else {
      document.getElementsByTagName('body')[0].style.pointerEvents = 'auto';
    }
  }, [isDisabled]);

  const handleFocus = () => {
    setIdParentSelected(null);
  };

  const handleInputChange = (e) => {
    setValueInput(e.target.value);
  };

  const onAdd = (e) => {
    if (e.keyCode === 13 || e.type === 'click') {
      setIdParentSelected(null);
      if (!valueInput) return;
      const requestId = new Date().getTime();
      const values = valueInput;
      const dataList = null;
      onCreateGroupMembers(requestId, values, dataList);
    }
  };

  const handleAddNewGroup = (folderId, itemName, isFolder) => {
    setIdParentSelected(folderId);
    if (isFolder) {
      let data = {
        namespace,
        name: itemName,
        parentGroupId: folderId,
        accountInfos: [],
      };
      let dataObj = {
        appServiceType: SERVICE.ADD_GROUP_MEMBER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  };

  useEffect(() => {
    if (addGroupMembers) {
      setExplorerDataList((state) => {
        const updateItemRecursively = (items) =>
          items.map((item) => {
            if (item.id === addGroupMembers.data.group.parentGroupId) {
              return {
                ...item,
                items: [
                  ...(item.items || []),
                  {
                    id: addGroupMembers.data.group.id,
                    name: addGroupMembers.data.group.name,
                    isFolder: true,
                    items: [],
                  },
                ],
              };
            } else if (item.items && item.items.length > 0) {
              return {
                ...item,
                items: updateItemRecursively(item.items),
              };
            }
            return item;
          });
        return updateItemRecursively(state);
      });
    }
  }, [addGroupMembers]);

  const [dataRemoveGroup, setDataRemoveGroup] = useState([]);

  const handleDeleteGroup = (currentExplorer) => {
    setError(false);
    setRecordSelected(currentExplorer);
    setIsPopupConfirmDeleteGroupVisible(true);
    // collectAllRelatedIds(explorerDataList, currentExplorer.id);
    setDataRemoveGroup(currentExplorer);
    checkSubGroupRemove(currentExplorer.id);
    setIdParentSelected(currentExplorer.id);
  };

  const handleDeleteMember = (currentExplorer) => {
    setError(false);
    setRecordSelected(currentExplorer);
    setIsPopupConfirmDeleteMemberVisible(true);
    // setIdParentSelected(currentExplorer.id);
  };

  const handleUpdateNameGroup = (id, updatedValue) => {
    handleUpdate(id, updatedValue);
  };

  const updateNode = (tree, folderId, itemName) => {
    if (tree.id === folderId) {
      return {
        ...tree,
        name: itemName,
      };
    }

    if (tree.items && tree.items.length > 0) {
      tree.items = tree.items.map((child) =>
        updateNode(child, folderId, itemName),
      );
    }

    return { ...tree };
  };

  const handleEdit = (member) => {
    setEditingId(member.id);
    setEditValue(member.name || '');
    setTimeout(() => inputValueRef.current?.focus(), 0);
  };

  const handleUpdate = (id, updatedValue) => {
    let data = {
      namespace,
      name: updatedValue,
      groupId: id,
    };
    let dataObj = {
      appServiceType: SERVICE.UPDATE_GROUP_MEMBER,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
    setEditingId(null);
    setExplorerDataList((state) => {
      const updateItemRecursively = (items) =>
        items.map((item) => {
          if (item.id === id) {
            return { ...item, name: updatedValue };
          } else if (item.items && item.items.length > 0) {
            return {
              ...item,
              items: updateItemRecursively(item.items),
            };
          }
          return item;
        });

      return updateItemRecursively(state);
    });
  };

  const handleOnCancel = (member) => {
    setEditValue(member.name || '');
    setEditingId(null);
  };

  const handleAddMember = () => {};

  useEffect(() => {
    if (
      updateMemberToNamespace &&
      updateMemberToNamespace.requestId === requestUpdateId
    ) {
      const { result, data, message } = updateMemberToNamespace;
      if (result === -3) {
        openMessage(NOTIFIES.WARNING, message);
      }
      if (result === 1) {
        openMessage(NOTIFIES.SUCCESS, message);
        handleUpdateMemberDone(data);
      }
    }
  }, [updateMemberToNamespace]);

  useEffect(() => {
    if (deleteWhiteListIP) {
      const { data, message, result } = deleteWhiteListIP;
      const { ipAddress } = data;
      if (result === 1) {
        openMessage(NOTIFIES.SUCCESS, message);
        setWhiteListIPs((state) =>
          state.filter((ip) => ip.ipAddress !== ipAddress),
        );
      } else {
        openMessage(NOTIFIES.ERROR, message);
        setWhiteListIPs((state) =>
          state.map((ip) =>
            ip.ipAddress !== ipAddress ? ip : { ...ip, loading: false },
          ),
        );
      }
    }
  }, [deleteWhiteListIP]);

  useEffect(() => {
    if (accountByNamespace && accountGroupMembers) {
      const members = accountByNamespace?.filter((item) => {
        return accountGroupMembers?.some(
          (member) => member.accountId === item.accountId,
        );
      });
      setMembersGroup(members);
    }
    if (listGroupByParentGroup?.groups?.length > 0) {
      const additionalGroups = listGroupByParentGroup.groups;

      setMembersGroup((prevMembersGroup) => [
        ...(prevMembersGroup || []),
        ...additionalGroups,
      ]);
    }

    const members = membersGroup;
    if (members && members.length > 0) {
      const updatedMembers = members.map((member) => {
        return {
          ...member,
          isFolder: member.parentGroupId != null && member.parentGroupId !== -1,
        };
      });
      const updateExplorerDataList = (
        data,
        idParentSelected,
        updatedMembers,
      ) => {
        return data.map((item) => {
          if (item.id === idParentSelected) {
            return { ...item, items: updatedMembers };
          } else if (item.items && item.items.length > 0) {
            return {
              ...item,
              items: updateExplorerDataList(
                item.items,
                idParentSelected,
                updatedMembers,
              ),
            };
          }
          return item;
        });
      };

      const updatedDataList = updateExplorerDataList(
        explorerDataList,
        idParentSelected,
        updatedMembers,
      );
      setExplorerDataList(updatedDataList);
    }
    setExplorerDataList((state) =>
      findAndSetLoading(state, idParentSelected, false),
    );
  }, [accountByNamespace, listGroupByParentGroup]);

  useEffect(() => {
    if (deleteWhiteListDevice) {
      const { data, message, result } = deleteWhiteListDevice;
      const { address } = data;
      if (result === 1) {
        openMessage(NOTIFIES.SUCCESS, message);
        setWhiteListDevices((state) =>
          state.filter((ip) => ip.address !== address),
        );
      } else {
        openMessage(NOTIFIES.ERROR, message);
        setWhiteListDevices((state) =>
          state.map((ip) =>
            ip.address !== address ? ip : { ...ip, loading: false },
          ),
        );
      }
    }
  }, [deleteWhiteListDevice]);

  useEffect(() => {
    if (deleteGroupMembers?.data?.groupId) {
      const groupId = deleteGroupMembers.data.groupId;

      setQueue((prevQueue) =>
        prevQueue.includes(groupId) ? prevQueue : [...prevQueue, groupId],
      );
    }
  }, [deleteGroupMembers]);

  useEffect(() => {
    if (queue.length === 0) return;

    const groupId = queue[0];

    setProgressMap((prev) => {
      if (prev[groupId] !== undefined) return prev;
      return { ...prev, [groupId]: 0 };
    });

    const interval = setInterval(() => {
      setProgressMap((prev) => {
        const currentProgress = prev[groupId] ?? 0;
        if (currentProgress >= 100) {
          clearInterval(interval);
          setQueue((prevQueue) => {
            const newQueue = prevQueue.slice(1);
            if (newQueue.length === 0) {
              const { data, message, result } = deleteGroupMembers;
              if (result === 1) {
                openMessage(NOTIFIES.SUCCESS, message);
              }
              setIsDisabled(false);
              setIsPopupConfirmDeleteGroupVisible(false);
            }
            return newQueue;
          });
          return { ...prev, [groupId]: 100 };
        }
        return { ...prev, [groupId]: currentProgress + 1 };
      });
    }, 10);

    return () => clearInterval(interval);
  }, [queue, deleteGroupMembers]);

  useEffect(() => {
    if (deleteGroupMembers) {
      const { data, message, result } = deleteGroupMembers;
      const { groupId } = data;
      if (result === 1) {
        setGroupMembers((state) => state?.filter((ip) => ip.id !== groupId));
        setGroupMembersDefault((state) =>
          state?.filter((ip) => ip.id !== groupId),
        );
      } else {
        setGroupMembers((state) =>
          state?.map((item) =>
            item.id !== groupId ? item : { ...item, loading: false },
          ),
        );
        setGroupMembersDefault((state) =>
          state?.map((item) =>
            item.id !== groupId ? item : { ...item, loading: false },
          ),
        );
      }
    }
  }, [deleteGroupMembers]);

  useEffect(() => {
    if (updateGroupMembers && groupMembers && groupMembers.length > 0) {
      const { message, result } = updateGroupMembers;
      let data1 = [...groupMembers];
      if (result === 1) {
        openMessage(NOTIFIES.SUCCESS, message);
        if (
          updateGroupMembers &&
          updateGroupMembers.data &&
          updateGroupMembers.data.group &&
          updateGroupMembers.data.group.id
        ) {
          groupMembers.map((item, index) => {
            if (item.id === updateGroupMembers.data.group.id) {
              data1[index] = {
                ...updateGroupMembers.data.group,
                index: item.index,
              };
            }
          });
          setGroupMembers(data1);
          setGroupMembersDefault(data1);
        }
      } else {
        openMessage(NOTIFIES.ERROR, message);
      }
    }
  }, [updateGroupMembers]);

  useEffect(() => {
    if (listWhitelistIPs) {
      setWhiteListIPs(
        listWhitelistIPs.map((ip, index) => ({
          ...ip,
          index: index + 1,
          loading: false,
        })),
      );
    }
    return () => {
      setWhiteListIPs(null);
    };
  }, [listWhitelistIPs]);

  useEffect(() => {
    if (listWhitelistDevices) {
      setWhiteListDevices(
        listWhitelistDevices.map((device, index) => ({
          ...device,
          index: index + 1,
          loading: false,
        })),
      );
    }
    return () => {
      setWhiteListDevices(null);
    };
  }, [listWhitelistDevices]);

  useEffect(() => {
    if (accountByNamespace && accountGroupMembers) {
      const members = accountByNamespace?.filter((item) => {
        return accountGroupMembers?.some(
          (member) => member.accountId === item.accountId,
        );
      });
      setMembersGroup(members);
    }
    if (listGroupByParentGroup?.groups?.length > 0) {
      dispatch(clearGroupAccountMember());
      dispatch(clearListGroupByParentGroup());

      const additionalGroups = listGroupByParentGroup.groups;

      setMembersGroup((prevMembersGroup) => [
        ...(prevMembersGroup || []),
        ...additionalGroups,
      ]);
    }
  }, [accountByNamespace, listGroupByParentGroup]);

  useEffect(() => {
    setExplorerDataList([]);
    if (listGroupMembers) {
      const dataTemp = listGroupMembers.map((groupMembers, index) => ({
        ...groupMembers,
        index: index + 1,
        loading: false,
        isFolder: true,
      }));
      setGroupMembers(dataTemp);
      for (let i = 0; i < dataTemp.length; i++) {
        // chỉ lấy những phần tử có parentGroupId = -1
        if (dataTemp[i].parentGroupId === -1) {
          setExplorerDataList((state) => [
            ...state,
            {
              id: dataTemp[i].id,
              name: dataTemp[i].name,
              isFolder: true,
              items: [],
              // isLoading: false,
            },
          ]);
        }
      }
      setGroupMembersDefault(dataTemp);

      // setExplorerDataList(dataTemp);
    }
    return () => {
      setGroupMembers(null);
      setGroupMembersDefault(null);
      // setExplorerDataList(null);
    };
  }, [listGroupMembers]);

  useEffect(() => {
    if (localNamespace) {
      setNamespace(localNamespace);
    }
  }, [localNamespace]);

  useEffect(() => {
    if (filterNotifications) {
      setDataNotifcation((state) => ({
        ...state,
        loading: false,
        data:
          filterNotifications.notifications?.filter((item) =>
            item?.content
              ?.toLowerCase()
              .includes(notificationInputSearch.toLowerCase()),
          ) || [],
        pagination: {
          ...state.pagination,
          total: filterNotifications.total,
        },
      }));
    }
  }, [filterNotifications, notificationInputSearch]);

  useEffect(() => {
    if (listDataSearch && listDataSearch.data) {
      setAccountByNamespaceData((state) => ({
        ...state,
        loading: false,
        data: listDataSearch?.data,
        pagination: {
          ...state.pagination,
          total: listDataSearch?.totalSize,
        },
      }));
    }
  }, [listDataSearch]);

  useEffect(() => {
    if (logsByNamespace) {
      setLogs((state) => ({
        ...state,
        loading: false,
        data: logsByNamespace.logs,
        pagination: {
          ...state.pagination,
          total: logsByNamespace.totalLogs,
        },
      }));
    }
  }, [logsByNamespace]);
  useEffect(() => {
    if (accountByNamespace && userId) {
      const dataTemp = accountByNamespace.map((acc, index) => ({
        ...acc,
        index: index + 1,
      }));
      setAccountByNamespaceData(dataTemp);
      setAccountByNamespaceDataDefault(dataTemp);
      setMemberTabLoading(false);
      const isAdmin = accountByNamespace.some(
        (account) => account.accountId === userId && account.role === 'admin',
      );

      if (isAdmin) {
        setIsAdmin(true);
        return; // Dừng lại nếu tìm thấy isAdmin là true
      }
    }
    if (dataUser) {
      const isAdmin =
        dataUser.role === 'admin' ||
        (dataUser.role === 'member' && dataUser.detailRole === 'operator');

      if (isAdmin) {
        setIsAdmin(true);
        return; // Dừng lại nếu tìm thấy isAdmin là true
      }
    }
    setIsAdmin(false); // Nếu không tìm thấy isAdmin là true, thì isAdmin sẽ là false
  }, [accountByNamespace, userId, dataUser]);

  useEffect(() => {
    if (
      isAuth === 1 &&
      namespace &&
      dateRanger?.length === 2 &&
      dataFilterType
    ) {
      setDataNotifcation((state) => ({
        ...state,
        data: state.data?.filter((item) =>
          item?.content
            ?.toLowerCase()
            .includes(notificationInputSearch.toLowerCase()),
        ),
        pagination: {
          current: 1,
          pageSize: 10,
        },
        loading: true,
      }));
      let data = {
        namespace,
        page: 0,
        size: 10,
        timeRequest,
        fromTime: dateRanger[0],
        toTime: dateRanger[1],
        type: dataFilterType,
        input: notificationInputSearch,
      };
      let dataObj = {
        appServiceType: SERVICE.FILTER_NOTIFICATION,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [
    dispatch,
    isAuth,
    namespace,
    timeRequest,
    dateRanger,
    dataFilterType,
    notificationInputSearch,
  ]);

  useEffect(() => {
    if (isAuth === 1 && namespace) {
      let data = {
        namespace,
        page: 0,
        size: 10,
        timeRequest,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACTION_LOG_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace, timeRequest]);

  useEffect(() => {
    if (isAuth === 1 && namespace) {
      setMemberTabLoading(true);
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACCOUNT_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  // useEffect(() => {
  //   if (isAuth === 1 && namespace && idParentSelected) {
  //     let data = {
  //       namespace,
  //       parentGroupId: idParentSelected,
  //     };
  //     let dataObj = {
  //       appServiceType: SERVICE.LIST_GROUP_BY_PARENT_GROUP,
  //       requestId: new Date().getTime(),
  //       body: JSON.stringify(data),
  //     };
  //     dispatch(socketEmitEvent(dataObj));
  //   }
  // }, [dispatch, isAuth, namespace, idParentSelected]);

  useEffect(() => {
    if (isAuth === 1 && namespace && userType) {
      let data = {
        namespace,
        userType,
      };

      let dataObjRole = {
        appServiceType: SERVICE.LIST_DETAIL_ROLE_OF_CUSTOMER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObjRole));
    }
  }, [dispatch, isAuth, namespace, userType]);

  useEffect(() => {
    if (isAuth === 1 && namespace && isAdmin) {
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_WHITE_LIST_IP_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAdmin, isAuth, namespace]);

  useEffect(() => {
    if (isAuth === 1 && namespace && isAdmin) {
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_WHITE_LIST_DEVICE_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAdmin, isAuth, namespace]);

  useEffect(() => {
    if (isAuth === 1 && namespace && isAdmin) {
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_GROUP_MEMBER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAdmin, isAuth, namespace]);

  useEffect(() => {
    if (percent === 100) {
      setTimeout(() => {
        setPercent(0);
      }, 1000);
    }
  }, [percent]);

  const orderDate = (arr) => {
    arr.sort(function (a, b) {
      return moment(b.updatedAt).valueOf() - moment(a.updatedAt).valueOf();
    });
    return arr;
  };

  const handleTableChangeNotification = useCallback(
    (pagination, _, sort) => {
      setDataNotifcation((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          pageSize: pagination.pageSize,
          current: pagination.current,
        },
        loading: true,
      }));

      let data = {
        namespace,
        page: pagination.current - 1,
        size: pagination.pageSize,
        timeRequest,
        fromTime: dateRanger[0],
        toTime: dateRanger[1],
        type: dataFilterType,
        input: notificationInputSearch,
      };
      let dataObj = {
        appServiceType: SERVICE.FILTER_NOTIFICATION,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [
      dispatch,
      namespace,
      timeRequest,
      dateRanger,
      dataFilterType,
      notificationInputSearch,
    ],
  );

  const handleSearchNotification = useCallback(
    (value) => {
      setDataNotifcation((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          pageSize: state.pagination.pageSize,
          current: 1,
        },
        loading: true,
      }));

      let data = {
        namespace,
        page: 0,
        size: dataNotification.pagination.pageSize,
        timeRequest,
        fromTime: dateRanger[0],
        toTime: dateRanger[1],
        type: dataFilterType,
        input: notificationInputSearch,
      };
      let dataObj = {
        appServiceType: SERVICE.FILTER_NOTIFICATION,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    },
    [
      dispatch,
      namespace,
      timeRequest,
      dateRanger,
      dataFilterType,
      notificationInputSearch,
    ],
  );

  const handleTableChange = useCallback(
    (pagination, _, sort) => {
      const { field, order } = sort;
      setLogs((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          current: pagination.current,
          pageSize: pagination.pageSize,
        },
        loading: true,
      }));
      if (dataSearchLogs) {
        let data = {
          action: dataFilterTypeLog,
          phonenumber: dataSearchLogs,
          namespace,
          page: pagination.current - 1,
          size: pagination.pageSize,
          timeRequest,
        };
        let dataObj = {
          appServiceType: SERVICE.LIST_ACTION_LOG_BY_PHONENUMBER,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      } else {
        let data = {
          action: dataFilterTypeLog,
          namespace,
          page: pagination.current - 1,
          size: pagination.pageSize,
          timeRequest,
        };
        let dataObj = {
          appServiceType: SERVICE.LIST_ACTION_LOG_BY_PHONENUMBER,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, timeRequest, dataSearchLogs, dataFilterTypeLog],
  );
  const onAddWhitelistIp = (requestId, values) => {
    const { ipAddress, namespace, fromMinute, toMinute } = values;
    let data = {
      ipAddress,
      namespace,
      fromMinute,
      toMinute,
    };
    let dataObj = {
      appServiceType: SERVICE.ADD_WHITE_LIST_IP,
      requestId,
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };
  const onAddWhitelistDevice = (requestId, values) => {
    const { address, namespace } = values;
    let data = {
      address,
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.ADD_WHITE_LIST_DEVICE,
      requestId,
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };
  const onAddMember = (requestId, values) => {
    const {
      phonenumber,
      namespace,
      fullName,
      email,
      role,
      detailRoles,
      position,
      authMethod,
      username,
      password,
      enableWatermark,
      accountStatus,
      expireTime,
      externalUserId,
    } = values;
    const normalizedExternalUserId =
      externalUserId === null || externalUserId === undefined
        ? ''
        : externalUserId.toString().trim();
    const data = {
      username,
      password,
      phonenumber,
      namespace,
      authMethod,
      fullName,
      email,
      role,
      detailRoles:
        (Array.isArray(detailRoles) ? detailRoles?.join(';') : detailRoles) ||
        '',
      expireTime: expireTime ? expireTime.format('YYYY-MM-DD HH:mm:ss') : '',
      enableWatermark: enableWatermark ? 1 : 0,
      accountStatus: accountStatus
        ? ACCOUNT_STATUS.ACTIVE
        : ACCOUNT_STATUS.BLOCKED,
      position: position || '',
      externalUserId: normalizedExternalUserId,
    };
    beeXLogger.debug('ADD_MEMBER - reqBody: ', data);
    const dataObj = {
      appServiceType: SERVICE.ADD_MEMBER,
      requestId,
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  const onConfigTimeoutMember = (dataConfig) => {
    const { liveTimeout, accountId, namespace } = dataConfig;
    const data = {
      liveTimeout,
      accountId,
      namespace,
    };
    const dataObj = {
      appServiceType: SERVICE.CONFIGURATION_USER,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };
  const onUpdateMember = (requestId, values) => {
    const {
      phonenumber,
      namespace,
      fullName,
      email,
      role,
      detailRoles,
      position,
      accountId,
      liveTimeout,
      username,
      password,
      authMethod,
      enableWatermark,
      accountStatus,
      expireTime,
      externalUserId,
    } = values;
    setRequestUpdateId(requestId);
    const normalizedExternalUserId =
      externalUserId === null || externalUserId === undefined
        ? ''
        : externalUserId.toString().trim();

    let data = {
      phonenumber,
      namespace,
      fullName,
      email,
      role,
      detailRoles:
        (Array.isArray(detailRoles) ? detailRoles?.join(';') : detailRoles) ||
        '',
      position: position || '',
      username,
      password,
      authMethod,
      expireTime: expireTime ? expireTime.format('YYYY-MM-DD HH:mm:ss') : '',
      enableWatermark: enableWatermark ? 1 : 0,
      accountStatus: accountStatus
        ? ACCOUNT_STATUS.ACTIVE
        : ACCOUNT_STATUS.BLOCKED,
      externalUserId: normalizedExternalUserId,
    };

    beeXLogger.debug('🚀 ~ UPDATE_MEMBER - onUpdateMember ~ data:', data);
    let dataObj = {
      appServiceType: SERVICE.UPDATE_MEMBER,
      requestId,
      body: JSON.stringify(data),
    };

    if (liveTimeout) {
      const dataObjConfig = {
        liveTimeout:
          moment(liveTimeout)?.hours() * 3600 +
          moment(liveTimeout)?.minutes() * 60,
        accountId,
        namespace,
      };
      onConfigTimeoutMember(dataObjConfig);
    }
    return dispatch(socketEmitEvent(dataObj));
  };

  const onResetPasswordMember = (requestId, values) => {
    beeXLogger.debug('RESET_USER_PASSWORD - values: ', values);
    const { accountId, password: newPassword, namespace } = values;

    let data = {
      accountId,
      namespace,
      newPassword,
    };
    beeXLogger.debug('RESET_USER_PASSWORD - data: ', data);

    let dataObj = {
      appServiceType: SERVICE.RESET_USER_PASSWORD,
      requestId,
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  const handleAddWhiteListIpDone = useCallback((data) => {
    setVisibleAddWhiteListIp(false);
    setKeyWhiteListIP(Math.random());
    return setWhiteListIPs((state) =>
      state && state.length > 0
        ? state.concat({
            index: state.length + 1,
            ipAddress: data.ipAddress,
            namespace: data.namespace,
            fromTime: data.fromMinute,
            toTime: data.toMinute,
            loading: false,
          })
        : [
            {
              index: 1,
              ipAddress: data.ipAddress,
              namespace: data.namespace,
              fromTime: data.fromMinute,
              toTime: data.toMinute,
              loading: false,
            },
          ],
    );
  }, []);

  const handleAddWhiteListDeviceDone = useCallback((data) => {
    setVisibleAddWhiteListDevice(false);
    setKey(Math.random());
    return setWhiteListDevices((state) =>
      state && state.length > 0
        ? state.concat({
            index: state.length + 1,
            address: data.address,
            namespace: data.namespace,
            loading: false,
          })
        : [
            {
              index: 1,
              address: data.address,
              namespace: data.namespace,
              loading: false,
            },
          ],
    );
  }, []);

  const handleAddGroupMemberDone = useCallback((data) => {
    setVisibleAddGroupMembers(false);
    setKey(Math.random());
    setGroupMembersDefault((state) =>
      state && state.length > 0
        ? state.concat({
            index: state.length + 1,
            id: (data.group && data.group.id) || '',
            name: (data.group && data.group.name) || '',
            namespace: (data.group && data.group.namespace) || '',
            loading: false,
          })
        : [
            {
              index: 1,
              id: (data.group && data.group.id) || '',
              name: (data.group && data.group.name) || '',
              namespace: (data.group && data.group.namespace) || '',
              loading: false,
            },
          ],
    );
    return setGroupMembers((state) =>
      state && state.length > 0
        ? state.concat({
            index: state.length + 1,
            id: (data.group && data.group.id) || '',
            name: (data.group && data.group.name) || '',
            namespace: (data.group && data.group.namespace) || '',
            loading: false,
          })
        : [
            {
              index: 1,
              id: (data.group && data.group.id) || '',
              name: (data.group && data.group.name) || '',
              namespace: (data.group && data.group.namespace) || '',
              loading: false,
            },
          ],
    );
  }, []);

  const handleAddMemberDone = useCallback(() => {
    setKeyMember(Math.random());
    if (isAuth === 1 && namespace) {
      setMemberTabLoading(true);
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACCOUNT_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  const onCloseModalAddMember = () => {
    setVisibleAddMember(false);
  };

  const handleUpdateMemberDone = useCallback(() => {
    setVisibleEditMember(null);
    if (isAuth === 1 && namespace) {
      setMemberTabLoading(true);
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACCOUNT_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  const handleResetPasswordMemberDone = useCallback(() => {
    setVisibleChangePassword(null);
  }, []);

  const onRemoveMember = useCallback(
    (record) => {
      confirm({
        title: `${t('Remove member with phone number as')} ${
          record.phonenumber
        }?`,
        icon: <ExclamationCircleOutlined />,
        okText: t('Remove'),
        onOk() {
          let data = {
            username: record.username,
            phonenumber: record.phonenumber,
            namespace,
          };
          let dataObj = {
            appServiceType: SERVICE.REMOVE_MEMBER,
            requestId: new Date().getTime(),
            body: JSON.stringify(data),
          };
          return dispatch(socketEmitEvent(dataObj));
        },
        onCancel() {},
      });
    },
    [dispatch, namespace, t],
  );

  useEffect(() => {
    if (removeMemberToNamespace && !visibleRemoveListMember) {
      if (removeMemberToNamespace?.result < 0) {
        openMessage(
          NOTIFIES.WARNING,
          removeMemberToNamespace.message
            ? removeMemberToNamespace.message
            : 'Remove member failed!',
        );
      } else {
        openMessage(
          NOTIFIES.SUCCESS,
          removeMemberToNamespace.message
            ? removeMemberToNamespace.message
            : 'Remove member successful!',
        );
      }
    }
    if (removeMemberToNamespace) {
      dispatch(ACTIONS.removeMemberToNamespaceReturn(null));
    }
  }, [removeMemberToNamespace, dispatch, visibleRemoveListMember]);

  const checkSubGroupRemove = (id) => {
    let data = {
      groupId: id,
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.CHECK_REMOVE_GROUP,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  const updateRemoveGroup = useCallback(() => {
    setDataRemoveGroup((prev) => [prev, ...checkRemoveGroup]);
  }, [checkRemoveGroup]);

  useEffect(() => {
    if (checkRemoveGroup) {
      updateRemoveGroup();
    }
  }, [checkRemoveGroup, updateRemoveGroup]);

  const onRemoveGroupMember = useCallback(
    (id) => {
      const collectAllRelatedIds = (items, targetId) => {
        let ids = [];
        items.forEach(({ id: itemId, items }) => {
          if (itemId === targetId) {
            ids.push(itemId);
            if (items?.length) {
              ids = ids.concat(
                items.flatMap(({ id }) => collectAllRelatedIds([id], id)),
              );
            }
          } else if (items?.length) {
            ids = ids.concat(collectAllRelatedIds(items, targetId));
          }
        });
        beeXLogger.debug('ids', ids);
        return ids;
      };

      const relatedIds = collectAllRelatedIds(explorerDataList, id);
      if (!relatedIds.length) return;

      relatedIds.forEach((groupId) => {
        dispatch(
          socketEmitEvent({
            appServiceType: SERVICE.DELETE_GROUP_MEMBER,
            requestId: Date.now(),
            body: JSON.stringify({ groupId, namespace }),
          }),
        );
      });

      setExplorerDataList((state) => {
        const removeItemRecursively = (items, idsToRemove) =>
          items
            .filter(({ id, items }) => !idsToRemove.includes(id))
            .map((item) =>
              item.items?.length
                ? {
                    ...item,
                    items: removeItemRecursively(item.items, idsToRemove),
                  }
                : item,
            );

        return removeItemRecursively(state, relatedIds);
      });
    },
    [dispatch, namespace, explorerDataList],
  );

  const handleRemoveIp = (index, ipAddress, namespace) => {
    confirm({
      title: t('_REMOVE_IP_FROM_WHITELIST_TITLE', { ip: ipAddress }),
      icon: <ExclamationCircleOutlined />,
      okText: t('Remove'),
      onOk() {
        setWhiteListIPs((state) =>
          state.map((ip) =>
            ip.index !== index ? ip : { ...ip, loading: true },
          ),
        );
        let data = {
          ipAddress,
          namespace,
        };
        let dataObj = {
          appServiceType: SERVICE.DELETE_WHITE_LIST_IP,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      },
      onCancel() {},
    });
  };

  const handleRemoveDevice = (index, address, namespace) => {
    confirm({
      title: t('_REMOVE_ADDRESS_FROM_WHITELIST_TITLE', { address: address }),
      icon: <ExclamationCircleOutlined />,
      okText: t('Remove'),
      onOk() {
        setWhiteListDevices((state) =>
          state.map((address) =>
            address.index !== index ? address : { ...address, loading: true },
          ),
        );
        let data = {
          address,
          namespace,
        };
        let dataObj = {
          appServiceType: SERVICE.DELETE_WHITE_LIST_DEVICE,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      },
      onCancel() {},
    });
  };

  const onCancelWhiteListDevice = () => {
    setVisibleAddWhiteListDevice(false);
    setKey(Math.random());
  };

  const onCancelGroupMember = () => {
    setVisibleAddGroupMembers(false);
    setKey(Math.random());
  };

  const onUpdateGroupMembers = (
    requestId,
    values,
    groupId,
    groupNameDefault,
  ) => {
    let data = {
      namespace,
      name: values?.name ?? groupNameDefault,
      groupId,
    };
    let dataObj = {
      appServiceType: SERVICE.UPDATE_GROUP_MEMBER,
      requestId,
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
    setVisibleAddGroupMembers(false);
    setKey(Math.random());
  };

  // const onCreateMembesGroup = (current, values, dataList) => {
  //   let data = {
  //     namespace,
  //     groupId: current.id,
  //     accountId: values.accountId,
  //     indexOf: current.index + 1,
  //   };
  //   let dataObj = {
  //     appServiceType: SERVICE.ADD_ACCOUNT_GROUP_MEMBER,
  //     requestId: new Date().getTime(),
  //     body: JSON.stringify(data),
  //   };
  //   dispatch(socketEmitEvent(dataObj));
  // };
  const onAddMemberGroup = (group, item) => {
    const foundAccount = accountByNamespaceData.find(
      (acc) => acc.accountId === item.accountId,
    );

    let data = {
      namespace,
      groupId: group.id,
      accountId: foundAccount.accountId,
      indexOf: group.index + 1,
    };

    let dataObj = {
      appServiceType: SERVICE.ADD_ACCOUNT_GROUP_MEMBER,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };

    dispatch(socketEmitEvent(dataObj));

    setExplorerDataList((state) => {
      const addAccountToGroup = (items) => {
        return items.map((item) => {
          const updatedItems = item.items || [];

          if (item.id === group.id) {
            const isExist = updatedItems.some(
              (member) => member.accountId === foundAccount.accountId,
            );

            return {
              ...item,
              items: isExist
                ? updatedItems
                : updatedItems.concat({
                    accountId: foundAccount.accountId,
                    fullName: foundAccount.fullName,
                    index: (item.index || 0) + 1,
                  }),
            };
          }

          if (updatedItems.length > 0) {
            return {
              ...item,
              items: addAccountToGroup(updatedItems),
            };
          }

          return item;
        });
      };

      return addAccountToGroup(state);
    });
  };

  const onCreateGroupMembers = (requestId, values, dataList) => {
    let data = {
      namespace,
      name: values.name || values,
      parentGroupId: idParentSelected ? idParentSelected : -1,
      accountInfos:
        dataList &&
        dataList.length > 0 &&
        dataList.map((item, index) => ({
          accountId: item.accountId,
          indexOf: index + 1,
        })),
    };

    let dataObj = {
      appServiceType: SERVICE.ADD_GROUP_MEMBER,
      requestId,
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
    setValueInput('');
    if (idParentSelected) {
      onExpandData(recordSelected);
    }
  };

  useEffect(() => {
    if (
      addGroupMembers &&
      addGroupMembers.result === 1 &&
      idParentSelected === null
    ) {
      setExplorerDataList((state) => [
        ...state,
        {
          id: addGroupMembers.data.group.id,
          name: addGroupMembers.data.group.name,
          isFolder: true,
          items: [],
        },
      ]);
    }
  }, [addGroupMembers]);

  const onExpandData = (record) => {
    setRecordSelected(record);

    setIdParentSelected(record.id);
  };

  const findAndSetLoading = (data, id, isLoading) => {
    return data.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          isLoading:
            typeof item.isLoading === 'boolean' ? isLoading : isLoading,
        };
      } else if (item.items && item.items.length > 0) {
        return {
          ...item,
          items: findAndSetLoading(item.items, id, isLoading),
        };
      }
      return item;
    });
  };

  const onHandleExpand = useCallback(
    (id) => {
      setIdParentSelected(id);
      setExplorerDataList((state) => findAndSetLoading(state, id, true));
      const timestamp = new Date().getTime();
      const groupData = {
        namespace,
        groupId: id,
      };
      dispatch(
        socketEmitEvent({
          appServiceType: SERVICE.LIST_ACCOUNT_GROUP_MEMBER,
          requestId: timestamp,
          body: JSON.stringify(groupData),
        }),
      );

      const subGroupData = {
        namespace,
        parentGroupId: id,
      };
      dispatch(
        socketEmitEvent({
          appServiceType: SERVICE.LIST_GROUP_BY_PARENT_GROUP,
          requestId: timestamp,
          body: JSON.stringify(subGroupData),
        }),
      );
    },
    [dispatch, namespace],
  );

  const updateExplorerDataList = useCallback(
    (data, parentId, updatedMembers) => {
      return data.map((item) => {
        if (item.id === parentId) {
          return { ...item, items: updatedMembers };
        } else if (item.items && item.items.length > 0) {
          return {
            ...item,
            items: updateExplorerDataList(item.items, parentId, updatedMembers),
          };
        }

        return item;
      });
    },
    [],
  );

  useEffect(() => {
    if (!idParentSelected || !membersGroup || membersGroup.length === 0) {
      return;
    }

    const updatedMembers = membersGroup.map((member) => ({
      ...member,
      isFolder: member.parentGroupId != null && member.parentGroupId !== -1,
    }));

    setExplorerDataList((prevDataList) =>
      updateExplorerDataList(prevDataList, idParentSelected, updatedMembers),
    );
    dispatch(clearGroupAccountMember());
    dispatch(clearListGroupByParentGroup());
  }, [idParentSelected, membersGroup, updateExplorerDataList]);

  const handleChangeSelect = (value) => {
    setDataFilterType(value);
  };

  const handleDownloadNotification = useCallback(async () => {
    try {
      setIsLoadingDownloadNotification(true);
      const token =
        storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);

      const dataQuery = {
        namespace,
        customerNamespace: namespace,
        isDownload: 1,
        type: dataFilterType,
        input: notificationInputSearch || '',
        fromTime: moment(dateRanger[0]).startOf('day').valueOf(),
        toTime: moment(dateRanger[1]).endOf('day').valueOf(),
      };

      const dataRes = await getReportNotificationsApi(
        token,
        { namespace: localNamespace },
        dataQuery,
      );

      if (!dataRes?.data) {
        ACTIONS.openMessage(NOTIFIES.WARNING, 'No data export');
        return;
      }

      const blob = new Blob([dataRes.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'report-members.xlsx';
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      ACTIONS.openMessage(
        NOTIFIES.WARNING,
        error?.response?.data?.message ?? 'Download failed',
      );
    } finally {
      setIsLoadingDownloadNotification(false);
    }
  }, [
    namespace,
    localNamespace,
    dataFilterType,
    notificationInputSearch,
    dateRanger,
  ]);

  const handleChangeSelectTypeLog = (value) => {
    setDataFilterTypeLog(value);
    onSearchLogs(dataSearchLogs, value);
  };

  const handleChangeSelectTypeMember = (value) => {
    setDataFilterTypeMember(value);
  };

  const handleDateRangerChange = (values) => {
    if (values?.length === 2) {
      const FromDate =
        values.length > 0
          ? values[0].set({ hour: 0, minute: 0, second: 0 })
          : '';
      const ToDate =
        values.length > 0
          ? values[1].set({ hour: 23, minute: 59, second: 59 })
          : '';
      const dataArr = [FromDate, ToDate];
      setDateRanger(dataArr.map((item) => Math.floor(moment(item).valueOf())));
      setKeyRanger(Math.random());
    } else {
      setDateRanger([]);
    }
  };

  const handleChangeDisconnect = (item, value) => {
    let dataInfo = (item?.extraInfo && JSON.parse(item.extraInfo)) || {};
    dataInfo.errorCode = value;
    item.status = 3;
    let data = {
      notificationId: item.id,
      status: 3,
      namespace,
      extraInfo: JSON.stringify({ ...dataInfo }),
    };
    let dataObj = {
      appServiceType: SERVICE.UPDATE_NOTIFICATION,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    setTimeout(() => {
      setPercent(100);
    }, 400);
    dispatch(socketEmitEvent(dataObj));
  };

  const onChangeAlert = (extraInfo) => {
    if (namespace) {
      let dataBody = {
        namespace,
        deviceTypeId: (extraInfo && JSON.parse(extraInfo)?.deviceTypeId) || 3,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ALERT,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  };

  const showModal = (data) => {
    setDataDetail(data);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setDataDetail(undefined);
    setIsPopupConfirmDeleteGroupVisible(false);
    setIsPopupConfirmDeleteMemberVisible(false);
  };

  const removeAccents = (str) => {
    return str
      ? str
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/đ/g, 'd')
          .replace(/Đ/g, 'D')
      : '';
  };

  const onSearchMember = (name) => {
    setMemberTabLoading(true);
    const keyword = name?.trim() || '';

    if (keyword) {
      setDataMemberSearch(keyword);
      setDataMember((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          current: 1,
          pageSize: 10,
        },
        loading: true,
      }));
      const dataName = removeAccents(keyword.toLowerCase());
      const timestamp = new Date().getTime() / 1000;
      let data = {
        applicationType: 'account',
        input: dataName,
        page: 0,
        size: 10,
        namespace,
        providerNamespace: null,
        timeRequest: timestamp,
      };

      let dataObj = {
        appServiceType: SERVICE.SEARCH_ADVANCE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };

      dispatch(socketEmitEvent(dataObj));
    } else {
      setDataMemberSearch('');
      setDataMember((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          current: 1,
          pageSize: state.pagination?.pageSize || 10,
        },
        loading: false,
      }));
      setAccountByNamespaceData(accountByNamespaceDataDefault);
    }

    setTimeout(() => {
      setMemberTabLoading(false);
    }, 400);
  };

  useEffect(() => {
    if (dataMemberSearch) {
      setDataMember((state) => ({
        ...state,
        pagination: {
          ...state.pagination,
          current: 1,
          pageSize: 10,
        },
        loading: true,
      }));
    }
  }, [dataMemberSearch]);

  useEffect(() => {
    if (
      dataMemberSearch &&
      Array.isArray(listDataSearch?.data) &&
      listDataSearch.data.length > 0
    ) {
      setAccountByNamespaceData(listDataSearch.data);
    } else if (
      dataMemberSearch &&
      (!Array.isArray(listDataSearch?.data) || listDataSearch.data.length === 0)
    ) {
      setAccountByNamespaceData([]);
    } else {
      setAccountByNamespaceData(accountByNamespaceDataDefault);
    }
  }, [listDataSearch, accountByNamespaceDataDefault, dataMemberSearch]);

  useEffect(() => {
    return () => {
      setAccountByNamespaceData({
        data: [],
        pagination: {},
        loading: false,
      });
      setAccountByNamespaceDataDefault({
        data: [],
        pagination: {},
        loading: false,
      });
      setDataMemberSearch('');
    };
  }, []);

  const onSearchGroupMember = (name) => {
    setGroupMemberTabLoading(true);
    setExplorerDataList([]);
    if (name?.trim()) {
      const dataName = removeAccents(name?.trim()?.toLowerCase());
      const dataSearch =
        groupMembersDefault?.filter((item) =>
          item.name?.toLowerCase()?.includes(dataName),
        ) ?? [];
      setGroupMembers(dataSearch);
      setExplorerDataList(dataSearch);
    } else {
      setGroupMembers(groupMembersDefault);
      setExplorerDataList(groupMembersDefault);
    }
    let data = {
      subName: name?.trim(),
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.SEARCH_GROUP_BY_NAME,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
    setTimeout(() => {
      setGroupMemberTabLoading(false);
    }, 400);
  };

  const onSearchLogs = (name, typeLog) => {
    setDataSearchLogs(name?.trim());
    setLogs((state) => ({
      ...state,
      pagination: {
        ...state.pagination,
        current: 1,
        pageSize: 10,
      },
      loading: true,
    }));
    if (name?.trim()) {
      let data = {
        action: typeLog ?? dataFilterTypeLog,
        phonenumber: name?.trim(),
        namespace,
        page: 0,
        size: 10,
        timeRequest,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACTION_LOG_BY_PHONENUMBER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    } else {
      let data = {
        action: typeLog ?? dataFilterTypeLog,
        namespace,
        page: 0,
        size: 10,
        timeRequest,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACTION_LOG_BY_PHONENUMBER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  };

  const onDownloadMember = async () => {
    try {
      const token =
        storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);

      const dataQuery = {
        namespace,
        customerNamespace: namespace,
        isDownload: 1,
      };

      const dataRes = await getExportReportsApi(
        token,
        { namespace: localNamespace },
        dataQuery,
      );

      if (!dataRes?.data) {
        ACTIONS.openMessage(NOTIFIES.WARNING, 'No data export');
        return;
      }

      const blob = new Blob([dataRes.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'report-members.xlsx';
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      ACTIONS.openMessage(
        NOTIFIES.WARNING,
        error?.response?.data?.message ?? 'Something went wrong',
      );
    } finally {
      setIsLoadingExport(false);
    }
  };

  const onDownloadLog = async () => {
    try {
      const token =
        storageService.getInternalStorageByKey(DECODED_ACCESS_TOKEN);
      const dataQuery = {
        customerNamespace: namespace,
        isDownload: 1,
        fromTime: 1502127477000,
        toTime: 1658480885000,
        action: 'Delete',
      };
      const dataRes = await getExportReportLogsApi(
        token,
        { namespace: localNamespace },
        dataQuery,
      );
      setTimeout(() => {
        if (dataRes?.data) {
          const buttonElement = document.createElement('a');
          buttonElement.href = `data:text/csv;charset=utf-8,${encodeURI(
            dataRes.data,
          )}`;
          buttonElement.target = '_blank';
          buttonElement.download = `report-action-logs.csv`;
          buttonElement.click();
        } else {
          ACTIONS.openMessage(NOTIFIES.WARNING, 'No data export');
        }
        setIsLoadingExportLog(false);
      }, 800);
    } catch (error) {
      setTimeout(() => {
        setIsLoadingExportLog(false);
        ACTIONS.openMessage(
          NOTIFIES.WARNING,
          error?.response?.data?.message ?? 'Internal server error',
        );
      }, 800);
    }
  };

  const extraInfoNotification = (item) => {
    var temple = '';
    switch (item.type) {
      case 'alert':
        temple = <div></div>;
        break;
      case 'event_object_detection':
        temple = (
          <div>
            <a>
              <img
                src={
                  item.extraInfo &&
                  JSON.parse(item.extraInfo) &&
                  (JSON.parse(item.extraInfo).imageUrl ??
                    JSON.parse(item.extraInfo).url)
                }
                style={{
                  width: '400px',
                  marginTop: '0.5rem',
                  marginLeft: '0.5rem',
                }}
                onClick={() => {
                  dispatch(
                    ACTIONS.popupVideoStorageFileByTimeReturn({
                      dataDetail: item,
                      isModalVisible: true,
                    }),
                  );
                }}
              />
            </a>
          </div>
        );
        break;
      case 'update_system':
        temple = (
          <div style={{ margin: '0.25rem 0 0 0.5rem' }}>
            <span style={{ fontSize: '12px', color: '#797979' }}>
              {t('Related effects')}:{' '}
              {item.content &&
                JSON.parse(item.content) &&
                JSON.parse(item.content).effect}
            </span>
          </div>
        );
        break;
      case 'add_device':
        temple = <div></div>;
        break;
      case 'remove_device':
        temple = <div></div>;
        break;
      case 'disconnected_device':
        temple = (
          <Row style={{ padding: '8px 8px 0px 8px', display: 'block' }}>
            <Col span={6}>
              <Select
                size="small"
                placeholder={t('Select reason')}
                style={{ width: '100%' }}
                defaultValue={
                  (item?.extraInfo && JSON.parse(item.extraInfo)?.errorCode) ||
                  undefined
                }
                onChange={(value) => handleChangeDisconnect(item, value)}
              >
                {listAlert?.map((item) => (
                  <Option value={item.errorCode}>{item.title}</Option>
                ))}
              </Select>
            </Col>
            {percent === 100 && (
              <Col span={6}>
                <Progress style={{ width: '100%' }} percent={percent} />
              </Col>
            )}
          </Row>
        );
        break;
      case 'advertise':
        temple = (
          <div>
            <span style={{ fontSize: '12px', color: '#797979' }}>
              {t('App description')}:{' '}
              {item.extraInfo &&
                JSON.parse(item.extraInfo) &&
                JSON.parse(item.extraInfo).summary}
            </span>
          </div>
        );
        break;
      default:
    }
    return temple;
  };

  const contentNotification = (item) => {
    var temple = '';
    switch (item.type) {
      case 'event_object_detection':
        let array_object =
          item.extraInfo &&
          JSON.parse(item.extraInfo) &&
          JSON.parse(item.extraInfo).objects &&
          JSON.parse(item.extraInfo).objects.split(',');
        let key_object = {};
        array_object &&
          array_object.forEach((e) => {
            if (e == 'car') {
              key_object.car = true;
            }
            if (e == 'motor') {
              key_object.motor = true;
            }
            if (e == 'gun') {
              key_object.gun = true;
            }
            if (e == 'knife') {
              key_object.knife = true;
            }
            if (e == 'person') {
              key_object.person = true;
            }
          });
        temple = (
          <div>
            <span>{item.content}</span>
            {key_object.person ? (
              <img style={{ marginLeft: '10px' }} src={PeopleNotification} />
            ) : (
              ''
            )}
            {key_object.car ? (
              <img style={{ marginLeft: '5px' }} src={CarNotification} />
            ) : (
              ''
            )}
            {key_object.knife ? (
              <img style={{ marginLeft: '5px' }} src={KnifeNotification} />
            ) : (
              ''
            )}
            {key_object.motor ? (
              <img style={{ marginLeft: '5px' }} src={MotobikeNotification} />
            ) : (
              ''
            )}
            {key_object.knife ? (
              <img style={{ marginLeft: '5px' }} src={SungNotification} />
            ) : (
              ''
            )}
          </div>
        );
        break;
      case 'update_system':
        temple = <span>{t('System upgrade schedule')}</span>;
        break;
      default:
        temple = <span>{item.content}</span>;
    }
    return temple;
  };

  const svgPrefixNotification = (item) => {
    var temple = '';
    switch (item.type) {
      case 'alert':
        temple = <img src={AlertNotification} />;
        break;
      case 'event_object_detection':
        temple = <img src={EventObjectDetectionNotification} />;
        break;
      case 'warning_detection':
        temple = <img src={CameraTampering} />;
        break;
      case 'update_system':
        temple = <img src={UpdateSystemNotification} />;
        break;
      case 'add_device':
        temple = <img src={AddDeviceNotification} />;
        break;
      case 'remove_device':
        temple = <img src={RemoveDeviceNotification} />;
        break;
      case 'disconnected_device':
        temple = <img src={DisconnectedDeviceNotification} />;
        break;
      case 'advertise':
        temple = <img src={AdvertiseNotification} />;
        break;
      default:
    }
    return temple;
  };

  const onDelete = (id, name) => {
    let data = {
      namespace,
      groupId: idParentSelected,
      accountId: id,
    };
    let dataObj = {
      appServiceType: SERVICE.DELETE_ACCOUNT_GROUP_MEMBER,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));

    setExplorerDataList((state) => {
      const removeItemRecursively = (items, idsToRemove) => {
        return items
          .filter((item) => !idsToRemove.includes(item.accountId))
          .map((item) => {
            if (item.items && item.items.length > 0) {
              return {
                ...item,
                items: removeItemRecursively(item.items, idsToRemove),
              };
            }
            return item;
          });
      };

      const updatedState = removeItemRecursively(state, [id]);
      return updatedState;
    });
    setIsPopupConfirmDeleteMemberVisible(false);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    const reader = new FileReader();

    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        raw: false,
        defval: '',
      });
      const formattedData = jsonData.slice(1).map((row) => ({
        phonenumber: row[0],
        namespace: namespace,
        fullName: row[1],
        email: row[2],
        position: row[3],
        role: row[4],
        detailRoles: row[5],
        username: row[6],
        password: row[7],
        externalUserId: row[8] ? row[8].toString().trim() : '',
      }));

      setFileData(formattedData);
    };

    reader.readAsArrayBuffer(file);
    e.target.value = '';
  };

  const submitFileUpload = () => {
    let index = 0;
    const interval = setInterval(() => {
      if (index < fileData.length) {
        const requestId = new Date().getTime();
        onAddMember(requestId, fileData[index]);
        index++;
      } else {
        clearInterval(interval);
      }
    }, 1000);
  };
  const onChangeAccountStatus = (checked, record) => {
    const requestId = new Date().getTime();
    setRequestUpdateId(requestId);
    const data = {
      accountStatus: checked ? ACCOUNT_STATUS.ACTIVE : ACCOUNT_STATUS.BLOCKED,
      username: record.username,
      namespace: record.namespace,
    };
    console.log('🚀 ~ UPDATE_MEMBER ~ data:', data);

    let dataObj = {
      appServiceType: SERVICE.UPDATE_MEMBER,
      requestId,
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  const onChangeEnableWatermark = (checked, record) => {
    const requestId = new Date().getTime();
    setRequestUpdateId(requestId);
    const data = {
      enableWatermark: checked ? 1 : 0,
      username: record.username,
      namespace: record.namespace,
    };

    let dataObj = {
      appServiceType: SERVICE.UPDATE_MEMBER,
      requestId,
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  const onChangeCreateSubGroup = (record) => {
    setVisibleAddGroupMembers(true);
    setDataArr({});
    setIdParentSelected(record.id);
  };

  const renderSubGroups = (membersGroup, parentId) => {
    return (
      <table className="table-child">
        {membersGroup
          ?.filter((member) => member.parentGroupId === parentId) // Lọc theo parentId
          .map((member) => (
            <tr
              key={member.id || member.accountId}
              style={{ marginBottom: '8px' }}
            >
              <td
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span
                    style={{ marginRight: 8, cursor: 'pointer' }}
                    onClick={() => toggleExpand(member)}
                  >
                    {expandedKeys[member.id] ? '-' : '+'}
                  </span>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    {member.fullName ? (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <UserOutlined style={{ marginRight: 8 }} />
                        {member.fullName} ({member.phonenumber})
                      </div>
                    ) : (
                      member.name
                    )}
                  </div>
                </div>
              </td>
              {expandedKeys[member.id] && ( // Đệ quy nếu có con
                <td>
                  <div style={{ marginLeft: 16, marginBottom: 16 }}>
                    {renderSubGroups(membersGroup, member.id)}
                  </div>
                </td>
              )}
            </tr>
          ))}
      </table>
    );
  };

  const handleMemberTableChange = (pagination, filters) => {
    const hasSearchKeyword = Boolean(dataMemberSearch?.trim());

    setDataMember((state) => ({
      ...state,
      pagination: {
        ...state.pagination,
        current: pagination.current,
        pageSize: pagination.pageSize,
      },
    }));

    if (filters) {
      setKeyMember(Math.random());
      let data = {
        namespace,
        status: filters?.['account_status'] ? filters?.['account_status']?.[0] : null,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACCOUNT_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
      return;
    }

    if (hasSearchKeyword) {
      setKeyMember(Math.random());
      const timestamp = new Date().getTime() / 1000;
      let data = {
        applicationType: 'account',
        input: removeAccents(dataMemberSearch.trim().toLowerCase()),
        page: pagination.current - 1,
        size: pagination.pageSize,
        namespace,
        providerNamespace: null,
        timeRequest: timestamp,
      };
      console.log(
        '🚀 ~ handleMemberTableChange - SEARCH_ADVANCE ~ data:',
        data,
      );
      let dataObj = {
        appServiceType: SERVICE.SEARCH_ADVANCE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  };

  return (
    <div className="system-component">
      <Modal
        className="modal-detail-notification"
        title={`Do you want to delete ${recordSelected?.fullName}?`}
        visible={isPopupConfirmDeleteMemberVisible}
        onCancel={handleCancel}
        style={{ top: 50 }}
        width="920px"
        bodyStyle={{ textAlign: 'center' }}
        footer={[
          <Button
            key="next"
            onClick={handleConfirmDeleteMember}
            style={{
              color: 'red',
              borderColor: 'red',
            }}
          >
            {t('Delete')}
          </Button>,
          <Button key="back" onClick={handleCancel}>
            {t('Close')}
          </Button>,
        ]}
      >
        {/* <Input
          autoFocus
          value={valueInputConfirm}
          onChange={(e) => setValueInputConfirm(e.target.value)}
        />
        {error && <p style={{ color: 'red' }}>{t('_CONFIRM_TITLE_ERROR')}</p>} */}
      </Modal>
      <Modal
        className="modal-detail-notification"
        title={t('_CONFIRM_REMOVE_GROUP', {
          name: recordSelected?.name,
        })}
        visible={isPopupConfirmDeleteGroupVisible}
        onCancel={!isDisabled ? handleCancel : null}
        style={{
          top: 50,
        }}
        width="920px"
        bodyStyle={{ textAlign: 'center' }}
        footer={[
          <Button
            key="next"
            onClick={handleConfirmDeleteGroup}
            style={{
              color: 'red',
              borderColor: 'red',
            }}
          >
            {t('Delete')}
          </Button>,
          <Button
            key="back"
            onClick={handleCancel}
            style={{
              opacity: isDisabled ? 0.5 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              pointerEvents: isDisabled ? 'none' : 'auto',
            }}
          >
            {t('Close')}
          </Button>,
        ]}
      >
        <div style={{ fontSize: '20px', textAlign: 'start' }}>
          List sub groups
        </div>
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '8px',
          }}
        >
          <thead style={{ marginBottom: '10px' }}>
            <tr style={{ borderBottom: '1px solid #3c3c3c' }}>
              <th
                style={{
                  padding: '12px 20px',
                  textAlign: 'left',
                  borderBottom: '1px solid #3c3c3c',
                  width: '50%',
                }}
              >
                Name
              </th>
              <th
                style={{
                  padding: '12px 20px',
                  textAlign: 'left',
                  borderBottom: '1px solid #3c3c3c',
                }}
              >
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(dataRemoveGroup) &&
              dataRemoveGroup.length > 0 &&
              dataRemoveGroup.map((item) => {
                const progress = progressMap[item.id] || 0;

                return (
                  <tr key={item.id} style={{ border: '1px solid #3c3c3c' }}>
                    <td style={{ padding: '16px 20px', textAlign: 'start' }}>
                      {item.name}
                    </td>
                    <td
                      style={{
                        // color: statusColor,
                        textAlign: 'start',
                      }}
                    >
                      {progress === 0 ? (
                        <span
                          style={{
                            color: '#7b7b7b',
                            border: `1px solid #7b7b7b`,
                            padding: '6px 12px',
                            width: '92px',
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          -
                        </span>
                      ) : progress === 100 ? (
                        <span
                          style={{
                            color: '#fff',
                            border: `1px solid transparent`,
                            backgroundColor: '#4f4d4d',
                            padding: '6px 12px',
                            width: '92px',
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          Deleted
                        </span>
                      ) : (
                        <span
                          style={{
                            color: '#e0b359',
                            border: `1px solid #e0b359`,
                            padding: '6px 12px',
                            width: '92px',
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          Deleting...
                        </span>
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {error && <p style={{ color: 'red' }}>{t('_CONFIRM_TITLE_ERROR')}</p>}
      </Modal>
      <Modal
        visible={visibleGroupMembers}
        title={
          dataArr && dataArr.name
            ? t('Update group members')
            : t('Add group members')
        }
        onCancel={() => onCancelGroupMember()}
        footer={null}
      >
        {visibleGroupMembers && (
          <AddGroupMember
            key={key}
            dataGroup={accountByNamespace}
            namespaceGroup={namespace}
            dataDevice={dataArr}
            onUpdateGroup={onUpdateGroupMembers}
            onCreateGroup={onCreateGroupMembers}
            onDone={handleAddGroupMemberDone}
          />
        )}
      </Modal>

      <Modal
        visible={visibleAddWhiteListIp}
        title={t('Add whitelist Ip')}
        onCancel={() => {
          setVisibleAddWhiteListIp(false);
          setKeyWhiteListIP(Math.random());
        }}
        footer={null}
      >
        {visibleAddWhiteListIp && (
          <AddWhitelistIPComponent
            key={keyWhiteListIP}
            namespace={namespace}
            onAdd={onAddWhitelistIp}
            onDone={handleAddWhiteListIpDone}
          />
        )}
      </Modal>
      <Modal
        visible={visibleAddWhiteListDevice}
        title={t('Add whitelist device')}
        onCancel={() => onCancelWhiteListDevice()}
        footer={null}
      >
        {visibleAddWhiteListDevice && (
          <AddWhitelistDeviceComponent
            key={key}
            namespace={namespace}
            onAdd={onAddWhitelistDevice}
            onDone={handleAddWhiteListDeviceDone}
          />
        )}
      </Modal>
      <Modal
        width={700}
        visible={visibleAddMember}
        title={t('Add new member')}
        onCancel={() => {
          onCloseModalAddMember();
          setKeyMember(Math.random());
        }}
        footer={null}
      >
        {visibleAddMember && (
          <AddMemberSteps
            setUserType={setUserType}
            setFileData={setFileData}
            fileData={fileData}
            keyMember={keyMember}
            handleFileUpload={handleFileUpload}
            namespace={namespace}
            onAddMember={onAddMember}
            handleAddMemberDone={handleAddMemberDone}
            onConfigTimeoutMember={onConfigTimeoutMember}
            submitFileUpload={submitFileUpload}
            onCloseModalAddMember={onCloseModalAddMember}
          />
        )}
      </Modal>
      <Modal
        visible={visibleEditMember}
        width="620px"
        title={t('Edit member')}
        onCancel={() => setVisibleEditMember(null)}
        footer={null}
      >
        {visibleEditMember && (
          <UpdateMemberComponent
            namespace={namespace}
            onUpdate={onUpdateMember}
            data={visibleEditMember}
            setUserType={setUserType}
          />
        )}
      </Modal>
      <Modal
        visible={visibleChangePassword}
        title={`${t('Change password for')}: ${
          visibleChangePassword?.fullName
        }`}
        onCancel={() => setVisibleChangePassword(null)}
        footer={null}
      >
        {visibleChangePassword && (
          <ChangePasswordComponent
            namespace={namespace}
            onUpdate={onResetPasswordMember}
            onDone={handleResetPasswordMemberDone}
            data={visibleChangePassword}
          />
        )}
      </Modal>
      <Modal
        className="modal-detail-notification"
        title={
          <div style={{ display: 'flex' }}>
            <div>{contentNotification(dataDetail ?? '')}</div>
            <div
              style={{
                color: '#797979',
                marginLeft: '8px',
                fontSize: '12px',
                marginTop: '3px',
              }}
            >
              {moment(dataDetail?.updatedAt).format('HH:mm:ss DD-MM-YYYY')}
            </div>
          </div>
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        style={{ top: 50 }}
        width="920px"
        bodyStyle={{ textAlign: 'center' }}
        footer={[
          <Button key="back" onClick={handleCancel}>
            {t('Close')}
          </Button>,
        ]}
      >
        {dataDetail && (
          <img
            src={
              dataDetail.extraInfo &&
              JSON.parse(dataDetail.extraInfo) &&
              (JSON.parse(dataDetail.extraInfo).imageUrl ??
                JSON.parse(dataDetail.extraInfo).url)
            }
            style={{ height: '478px' }}
          />
        )}
      </Modal>

      <Modal
        visible={Boolean(visibleRemoveListMember)}
        title={t('Remove list members')}
        onCancel={() => {
          setVisibleRemoveListMember(false);
          setKey(Math.random());
        }}
        width={800}
        footer={null}
      >
        <RemoveListMember
          namespace={namespace}
          visible={visibleRemoveListMember}
          accountByNamespace={accountByNamespace}
        />
      </Modal>

      <Tabs
        size="large"
        tabPosition="left"
        defaultActiveKey="notifications"
        onChange={(value) => setCurrentTab(value)}
      >
        <TabPane
          tab={
            <span style={{ fontSize: '14px' }}>
              <img
                className="system-icon"
                alt="Action-notification"
                src={Action_logs}
              />
              {t('Notification')}
            </span>
          }
          key="notifications"
        >
          {currentTab === 'notifications' && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                paddingBottom: '5px',
                gap: 15,
              }}
            >
              <Select
                defaultValue={dataFilterType}
                style={{ width: 180 }}
                onChange={handleChangeSelect}
              >
                <Option value="disconnected_device">
                  {t('Disconnected device')}
                </Option>
                <Option value="warning_detection">
                  {t('Warning detection')}
                </Option>
                <Option value="alert">{t('Alert')}</Option>
                <Option value="event_object_detection">
                  {t('Event object detection')}
                </Option>
                <Option value="update_system">{t('Update System')}</Option>
                <Option value="add_device">Add device</Option>
                <Option value="remove_device">{t('Remove device')}</Option>
                <Option value="advertise">{t('Advertise')}</Option>
              </Select>
              <RangePicker
                key={keyRanger}
                value={[moment(dateRanger?.[0]), moment(dateRanger?.[1])]}
                onChange={handleDateRangerChange}
                allowClear={false}
              />
              <Input.Search
                placeholder={t('Search by name')}
                onChange={(e) => setNotificationInputSearch(e.target.value)}
                allowClear
                style={{ width: 240 }}
                value={notificationInputSearch}
                onSearch={handleSearchNotification}
              />
              <Button
                type="primary"
                onClick={handleDownloadNotification}
                loading={isLoadingDownloadNotification}
                disabled={
                  isLoadingDownloadNotification ||
                  !dataNotification?.data?.length
                }
                icon={<DownloadOutlined />}
              >
                {t('Download')}
              </Button>
            </div>
          )}
          <Table
            dataSource={
              dataNotification &&
              dataNotification.data &&
              dataNotification.data.map((dataNotif, key) => ({
                ...dataNotif,
                key: dataNotif?.id,
              }))
            }
            pagination={dataNotification && dataNotification.pagination}
            loading={dataNotification && dataNotification.loading}
            onChange={handleTableChangeNotification}
            columns={[
              {
                title: t('Name'),
                dataIndex: 'name',
                key: 'notif_name',
                render: (text, row) => (
                  <div style={{ display: 'flex' }}>
                    <span style={{ marginRight: '8px' }}>
                      {svgPrefixNotification(row)}
                    </span>
                    <span>{contentNotification(row)}</span>
                  </div>
                ),
              },
              {
                title: t('Created at'),
                width: 200,
                key: 'notif_date',
                dataIndex: 'updatedAt',
                render: (time) => moment(time).format('HH:mm:ss DD-MM-YYYY'),
              },
            ]}
            expandedRowKeys={expKeys}
            expandable={{
              expandedRowRender: (record) => (
                <div>{extraInfoNotification(record)}</div>
              ),
            }}
            onExpand={(expanded, record) => {
              setExpKeys(expanded ? [record?.id] : []);
              if (expanded) {
                onChangeAlert(record?.extraInfo);
              }
            }}
          />
        </TabPane>
        <TabPane
          tab={
            <span style={{ fontSize: '14px' }}>
              <img
                className="system-icon"
                alt="Action-logs"
                src={Action_logs}
              />
              {t('Action logs')}
            </span>
          }
          key="logs"
        >
          <ActionLog />
        </TabPane>
        {isAdmin && (
          <TabPane
            tab={
              <span style={{ fontSize: '14px' }}>
                <img
                  className="system-icon"
                  alt="Group-Members"
                  src={Group_Members}
                />
                {t('Group Members')}
              </span>
            }
            key="group-members"
          >
            {currentTab === 'group-members' && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  paddingBottom: '5px',
                }}
              >
                <Search
                  placeholder={t('Search by name')}
                  onSearch={onSearchGroupMember}
                  style={{ width: 240, marginRight: '16px' }}
                  allowClear
                />
                {/* <Button onClick={() => onChangeCreate()}>
                  {t('Add group members')}
                </Button> */}
              </div>
            )}
            {/* <div>{renderGroupMembers(groupMembers || [])}</div> */}
            <div className="App">
              <div className="folderContainerBody">
                <div className="folder-container">
                  {explorerDataList?.map(
                    (explorerData) =>
                      explorerData && (
                        <Folder
                          key={explorerData.id}
                          handleAddNewGroup={handleAddNewGroup}
                          handleDeleteGroup={handleDeleteGroup}
                          handleDeleteMember={handleDeleteMember}
                          handleUpdateNameGroup={handleUpdateNameGroup}
                          explorerData={explorerData}
                          onHandleExpand={onHandleExpand}
                          onAddMemberGroup={onAddMemberGroup}
                          // onCreateMembesGroup={onCreateMembesGroup}
                        />
                      ),
                  )}
                </div>
                {/* <div className="empty-state">Your content will be here</div> */}
              </div>
            </div>
            {/* {showInput.visible && ( */}
            <div className="new-group">
              <div>
                <VscFolder color="#0e9347" />
                <input
                  type="text"
                  onFocus={handleFocus}
                  // autoFocus
                  // onBlur={() =>
                  //   setShowInput({ ...showInput, visible: false })
                  // }
                  value={valueInput}
                  onChange={handleInputChange}
                  placeholder="Add new group..."
                  style={{ marginLeft: '4px' }}
                  onKeyDown={onAdd}
                />
              </div>
              <div>
                <button
                  onClick={onAdd}
                  style={{
                    marginRight: '8px',
                    backgroundColor: '#000',
                    color: '#0e9347',
                  }}
                >
                  Create
                </button>
                <button
                  style={{ backgroundColor: '#000', color: '#4f4d4d' }}
                  onClick={handleOnCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
            {/* )} */}
            {/* <Button onClick={() => hanldleAddGroup()}>
              {t('Add group members')}
            </Button> */}
          </TabPane>
        )}
        {isAdmin && (
          <TabPane
            tab={
              <span style={{ fontSize: '14px' }}>
                <img className="system-icon" alt="Members" src={Members} />
                {t('Members')}
              </span>
            }
            key="member"
          >
            {currentTab === 'member' && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  paddingBottom: '5px',
                }}
              >
                <Search
                  placeholder="Search..."
                  onSearch={onSearchMember}
                  style={{ width: 240, marginRight: '16px' }}
                  allowClear
                />
                <Button
                  onClick={() => setVisibleAddMember(true)}
                  icon={<PlusOutlined />}
                  type="primary"
                >
                  {t('Add member')}
                </Button>
                <Button
                  style={{ marginLeft: '16px' }}
                  onClick={() => setVisibleRemoveListMember(true)}
                  icon={<UserDeleteOutlined />}
                >
                  {t('Remove members')}
                </Button>
                <Button
                  style={{ marginLeft: '16px' }}
                  loading={isLoadingExport}
                  type="primary"
                  onClick={() => {
                    onDownloadMember();
                    setIsLoadingExport(true);
                  }}
                  icon={<DownloadOutlined />}
                >
                  {t('Download reports')}
                </Button>
              </div>
            )}
            <Table
              loading={memberTabLoading}
              pagination={{
                current: dataMember?.pagination?.current,
                total: dataMemberSearch?.trim()
                  ? (listDataSearch?.totalSize ?? 0)
                  : (accountByNamespace?.length ?? 0),
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100', '200'],
              }}
              expandable={{
                expandedRowRender: (record) => {
                  const { sessions } = record;
                  return (
                    <Fragment>
                      {sessions.map((session, index) => (
                        <div className="session" key={index}>
                          <p>
                            <span>Client IP: </span>
                            {session.clientIp}
                          </p>
                          <p>
                            <span>Device: </span>
                            {session.deviceInfo}
                          </p>
                          <p>
                            <span>Online at: </span>
                            {session.onlineAt}
                          </p>
                          <Divider />
                        </div>
                      ))}
                    </Fragment>
                  );
                },
                rowExpandable: (record) => record?.sessions?.length,
              }}
              columns={[
                {
                  title: t('Full name'),
                  dataIndex: 'fullName',
                  key: 'member_fullName',
                },
                {
                  title: t('Phone number'),
                  dataIndex: 'phonenumber',
                  key: 'member_phonenumber',
                },
                {
                  title: t('Email'),
                  dataIndex: 'email',
                  key: 'member_email',
                  render: (emails) => (
                    <span>{emails?.split(';')?.join('; ') ?? ''}</span>
                  ),
                },
                {
                  title: t('Position'),
                  dataIndex: 'position',
                  key: 'member_position',
                  render: (position) => (
                    <Tooltip title={position || '-'}>
                      <span>{position || '-'}</span>
                    </Tooltip>
                  ),
                },
                {
                  title: 'External Id',
                  dataIndex: 'externalUserId',
                  key: 'externalUserId',
                  width: 50,
                  render: (value) => value || '-',
                },
                {
                  title: t('UserType'),
                  key: 'member_role',
                  dataIndex: 'role',
                  render: (tags) => (
                    <Tag color={memberRoleColors(tags)}>
                      {USER_TYPE_OPTIONS.find(
                        (item) => item.value === tags,
                      )?.label?.toUpperCase()}
                    </Tag>
                  ),
                },
                {
                  title: t('Role'),
                  key: 'member_detailRoles',
                  dataIndex: 'detailRoles',
                  render: (text) => (
                    <>
                      {text &&
                        text?.split(';')?.map((item, index) =>
                          item?.trim() ? (
                            <Tag
                              key={index}
                              color={colorsDark.$online}
                              style={{
                                fontSize: '10px',
                                marginRight: '5px',
                                marginBottom: '2px',
                              }}
                            >
                              {item?.replaceAll('-', ' ')?.toUpperCase() || ''}
                            </Tag>
                          ) : null,
                        )}
                    </>
                  ),
                },
                {
                  title: t('Watermark'),
                  key: 'member_watermark',
                  render: (record) => {
                    const detailRolesArr = record.detailRoles?.split(';') || [];
                    const isAdminDetailRole = detailRolesArr.some(
                      (item) => item.split('-')?.[0] === 'admin',
                    );
                    const isRecordAdmin =
                      record.role === 'admin' && isAdminDetailRole;
                    return (
                      <div>
                        {(isAdmin || record.accountId === userId) &&
                          !isRecordAdmin && (
                            <Tooltip
                              title={
                                record?.enableWatermark
                                  ? t('Enabled')
                                  : t('Disabled')
                              }
                            >
                              <Switch
                                checked={record?.enableWatermark}
                                onChange={(checked, event) =>
                                  onChangeEnableWatermark(checked, record)
                                }
                              />
                            </Tooltip>
                          )}
                      </div>
                    );
                  },
                },
                {
                  title: t('Active status'),
                  key: 'account_status',
                  render: (record) => {
                    const detailRolesArr = record.detailRoles?.split(';') || [];
                    const isAdminDetailRole = detailRolesArr.some(
                      (item) => item.split('-')?.[0] === 'admin',
                    );
                    const isRecordAdmin =
                      record.role === 'admin' && isAdminDetailRole;
                    return (
                      <div>
                        {(isAdmin || record.accountId === userId) &&
                          !isRecordAdmin && (
                            <Tooltip
                              title={
                                record?.accountStatus === ACCOUNT_STATUS.ACTIVE
                                  ? t('Available')
                                  : t('Blocked')
                              }
                            >
                              <Switch
                                checked={
                                  record?.accountStatus ===
                                  ACCOUNT_STATUS.ACTIVE
                                }
                                onChange={(checked, event) =>
                                  onChangeAccountStatus(checked, record)
                                }
                              />
                            </Tooltip>
                          )}
                      </div>
                    );
                  },

                  filterMultiple: false,
                  filters: [
                    {
                      text: t('Available'),
                      value: ACCOUNT_STATUS.ACTIVE,
                    },
                    {
                      text: t('Blocked'),
                      value: ACCOUNT_STATUS.BLOCKED,
                    },
                  ],
                },
                {
                  title: t('Expire time'),
                  key: 'expire_time',
                  dataIndex: 'expireTime',
                },
                {
                  title: t('Action'),
                  key: 'actions ',
                  render: (record) => {
                    const detailRolesArr = record.detailRoles?.split(';') || [];
                    const isAdminDetailRole = detailRolesArr.some(
                      (item) => item.split('-')?.[0] === 'admin',
                    );
                    const isRecordAdmin =
                      record.role === 'admin' && isAdminDetailRole;

                    return (
                      <div className="manager-member-actions">
                        {(isAdmin || record.accountId === userId) &&
                          !isRecordAdmin && (
                            <Tooltip title={t('Edit')}>
                              <div
                                className="edit-button"
                                onClick={() => setVisibleEditMember(record)}
                              >
                                <EditOutlined />
                              </div>
                            </Tooltip>
                          )}

                        {isAdmin && !isRecordAdmin && (
                          <Tooltip title={t('Change password')}>
                            <div
                              className="edit-button"
                              onClick={() => setVisibleChangePassword(record)}
                            >
                              <KeyOutlined />
                            </div>
                          </Tooltip>
                        )}
                        {isAdmin && !isRecordAdmin && (
                          <Tooltip title={t('Remove')}>
                            <div
                              className="edit-button error"
                              onClick={() => onRemoveMember(record)}
                            >
                              <DeleteOutlined
                                disabled={record.role === 'admin'}
                              />{' '}
                            </div>
                          </Tooltip>
                        )}
                      </div>
                    );
                  },
                },
              ]}
              dataSource={
                accountByNamespaceData &&
                accountByNamespaceData.map((account) => ({
                  ...account,
                  key: account.index,
                }))
              }
              onChange={handleMemberTableChange}
              className="members-table"
            />
          </TabPane>
        )}
        <TabPane
          disabled={!isAdmin}
          tab={
            <span style={{ fontSize: '14px' }}>
              <img
                className="system-icon"
                alt="Whitlist-IP"
                src={Whitlist_IP}
              />
              {t('Whitelist IP')}
            </span>
          }
          key="white-list"
        >
          {currentTab === 'white-list' && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                paddingBottom: '5px',
              }}
            >
              <Button onClick={() => setVisibleAddWhiteListIp(true)}>
                {t('Add whitelist Ip')}
              </Button>
            </div>
          )}
          <Table
            loading={!whiteListIPs}
            columns={[
              {
                title: t('Index'),
                dataIndex: 'index',
                key: 'id_ip',
              },
              {
                title: t('IP Address'),
                dataIndex: 'ipAddress',
                key: 'ipAddress_ip',
              },
              {
                title: t('Namespace'),
                dataIndex: 'namespace',
                key: 'namespace_ip',
              },
              {
                title: t('From'),
                dataIndex: 'fromTime',
                key: 'fromTime_ip',
                width: 200,
                render: (time) => getTimeFromMins(time),
              },
              {
                title: t('To'),
                dataIndex: 'toTime',
                key: 'toTime_ip',
                width: 200,
                render: (time) => getTimeFromMins(time),
              },
              {
                title: t('Action'),
                key: 'action-share-device',
                width: 120,
                render: (ip) => (
                  <div className="manager-member-actions">
                    <div
                      className="edit-button"
                      onClick={() =>
                        handleRemoveIp(ip.index, ip.ipAddress, ip.namespace)
                      }
                    >
                      <DeleteOutlined /> {t('Remove')}
                    </div>
                  </div>
                ),
              },
            ]}
            dataSource={
              whiteListIPs &&
              whiteListIPs.map((ip) => ({
                ...ip,
                key: ip.index,
              }))
            }
          />
        </TabPane>
        <TabPane
          disabled={!isAdmin}
          tab={
            <span style={{ fontSize: '14px' }}>
              <img
                className="system-icon"
                alt="Whitelist-Device"
                src={Whitelist_Device}
              />
              {t('Whitelist Device')}
            </span>
          }
          key="white-list-device"
        >
          {currentTab === 'white-list-device' && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                paddingBottom: '5px',
              }}
            >
              <Button onClick={() => setVisibleAddWhiteListDevice(true)}>
                {t('Add whitelist device')}
              </Button>
            </div>
          )}
          <Table
            loading={!whiteListDevices}
            columns={[
              {
                title: t('Index'),
                dataIndex: 'index',
                key: 'id_ip',
              },
              {
                title: t('MAC Address'),
                dataIndex: 'address',
                key: 'ipAddress_ip',
              },
              {
                title: t('Namespace'),
                dataIndex: 'namespace',
                key: 'namespace_ip',
              },
              {
                title: t('Action'),
                key: 'action-share-device',
                width: 120,
                render: (ip) => (
                  <div className="manager-member-actions">
                    <div
                      className="edit-button"
                      onClick={() =>
                        handleRemoveDevice(ip.index, ip.address, ip.namespace)
                      }
                    >
                      <DeleteOutlined /> {t('Remove')}
                    </div>
                  </div>
                ),
              },
            ]}
            dataSource={
              whiteListDevices &&
              whiteListDevices.map((device) => ({
                ...device,
                key: device.index,
              }))
            }
          />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default SystemPage;
